import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UIModule } from '@c4/ui';

import { ProgrammingCommonModule } from '../../common/common.module';
import { QuickstartCommonModule } from '../quickstart-common/quickstart-common.module';

import { QSMediaService } from './quickstart-media.service';

import { QSMediaComponent } from './quickstart-media.component';
import { QSMediaSelectRoomComponent } from './select-room/select-room.component';
import { QSMediaSelectMediaComponent } from './select-media/select-media.component';
import { QSMediaSelectRemoteComponent } from './select-remote/select-remote.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UIModule,
    ProgrammingCommonModule,
    QuickstartCommonModule
  ],
  providers: [
    QSMediaService
  ],
  declarations: [
    QSMediaComponent,
    QSMediaSelectRoomComponent,
    QSMediaSelectMediaComponent,
    QSMediaSelectRemoteComponent
  ]
})
export class QuickstartMediaModule { }



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-media/quickstart-media.module.ts